import { useEffect } from "react";

export default function SEO({ title, description, path = "" }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | AMVI Technologies`
      : "AMVI Technologies — AI, Data, Cloud & Talent Solutions (USA)";
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const desc =
      description ||
      "AMVI Technologies delivers AI, data, cloud, engineering and specialized talent solutions to help U.S. organizations accelerate digital transformation.";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");

    const origin = window.location.origin;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${origin}${path}`);
    setMeta("property", "og:url", `${origin}${path}`);
  }, [title, description, path]);

  return null;
}
